"use client";

import Pagination from "../../../common/Pagination";
import BaseStorePage from "../shared/base-store-page";
import CoverPage from "./cover-page";
import FloatingHelper from "./floating-helper";
import styles from "./index.module.css";
import ProductItem from "./product/product-card";
import SkeletonCard from "./skeleton-card";
import StoreBox from "./store-box";

const getShouldHideCategoryCover = ({ activeCategoryData }) =>
  Boolean(activeCategoryData) && !activeCategoryData.imageUrl;

const getShouldShowCover = (viewState) =>
  !viewState.isMobile &&
  viewState.searchTerm === "" &&
  viewState.hasTyped === false &&
  !getShouldHideCategoryCover(viewState);

const getShowHeaderSearch = (viewState) =>
  viewState.searchTerm !== "" || getShouldHideCategoryCover(viewState);

const getForceHeaderSearch = getShouldHideCategoryCover;

const getCoverProps = ({ activeCategoryData }) => ({
  activeCategory: activeCategoryData,
});

const renderConvetiEmptyState = ({
  hasActiveSearch,
  setHasTyped,
  setSearchTerm,
  styles,
}) => (
  <div className={styles.emptystate}>
    <div className={styles.emptyStateArt} aria-hidden="true">
      <span />
      <span />
      <span />
    </div>
    <div className={styles.emptyStateCopy}>
      <span className={styles.emptyStateEyebrow}>
        {hasActiveSearch ? "No matches" : "No products"}
      </span>
      <h3>
        {hasActiveSearch
          ? "Nothing matched your search"
          : "New products are coming soon"}
      </h3>
      <p>
        {hasActiveSearch
          ? "Try a different keyword or clear your search to browse the full collection."
          : "This collection is being updated. Check back soon for the latest arrivals."}
      </p>
      {hasActiveSearch && (
        <button
          type="button"
          className={styles.emptyStateButton}
          onClick={() => {
            setSearchTerm("");
            setHasTyped(false);
          }}
        >
          Clear Search
        </button>
      )}
    </div>
  </div>
);

function StorePage(props) {
  return (
    <BaseStorePage
      {...props}
      styles={styles}
      StoreBox={StoreBox}
      ProductItem={ProductItem}
      SkeletonCard={SkeletonCard}
      CoverPage={CoverPage}
      FloatingHelper={FloatingHelper}
      Pagination={Pagination}
      renderEmptyState={renderConvetiEmptyState}
      getShouldShowCover={getShouldShowCover}
      getShowHeaderSearch={getShowHeaderSearch}
      getForceHeaderSearch={getForceHeaderSearch}
      getCoverProps={getCoverProps}
      paginationVariant="conveti"
    />
  );
}

export default StorePage;
